


























import { Component, Prop, Vue } from 'vue-property-decorator';
import { Typography } from '@/components/atoms';
import { pluralize } from '@/utils';

@Component({
  components: {
    Typography
  }
})
export default class OverviewAppOfferPreview extends Vue {
  @Prop() coins?: string;

  get business() {
    return this.$store.getters['business/getBusinessState'];
  }

  get businessLogo() {
    return this.business.logo.publicPath.small;
  }

  get textTitle() {
    const coins = Number(this.coins) || 0;

    return `${coins} ${pluralize(coins, 'Coin')}`;
  }
}
